import { translate } from '@ngneat/transloco';

import { Forward, VoiceResponseCommand, VoiceResponseCommandName } from '@pwp-common';

import { RowCell } from '../../../../common/p-table/row-cell';

export const summarizeVRCArray = (commands: VoiceResponseCommand[]): RowCell<string> => {
  if (commands.length === 0) {
    return new RowCell({
      translationScope: 'service-operation-editor',
      translationKey: 'noCommands',
      sortValue: '',
    });
  }

  const summary = commands.map((command) => getCommandDescription(command)).join(' -> ');

  return createSummaryCell(summary);
};

const createSummaryCell = (value: string): RowCell<string> =>
  new RowCell<string>({
    translationScope: 'service-operation-editor',
    translationKey: 'summarizedVRCArray',
    translationObj: { value },
    sortValue: value,
  });

const getCommandDescription = (command: VoiceResponseCommand): string => {
  const commandName = translate(`service-command-name-select.${command.getCommandName()}`);

  switch (command.getCommandName()) {
    case VoiceResponseCommandName.forward:
      return translate('service-operation-editor.forwardCommandDescription', {
        commandName,
        phoneNumber: (command as Forward).getTo(),
      });
    default:
      return commandName;
  }
};